import { Injectable, signal } from '@angular/core';

/**
 * Global open/close state for the referral popup, so any trigger (the sidebar "Earn up to $500"
 * item today, a dashboard button tomorrow) can pop the same modal without prop-drilling.
 */
@Injectable({ providedIn: 'root' })
export class ReferralModalService {
  readonly isOpen = signal(false);

  open(): void {
    this.isOpen.set(true);
  }

  close(): void {
    this.isOpen.set(false);
  }
}
